import { render, staticRenderFns } from "./ClassificacaoWindowLI.vue?vue&type=template&id=55f8112a&scoped=true&"
import script from "./ClassificacaoWindowLI.vue?vue&type=script&lang=js&"
export * from "./ClassificacaoWindowLI.vue?vue&type=script&lang=js&"
import style0 from "./ClassificacaoWindowLI.vue?vue&type=style&index=0&id=55f8112a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f8112a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
